import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotowallRoutes } from './photowall.route.module';
import { UploadEventQrComponent } from '../upload-event-qr/upload-event-qr.component';
import { AddHashtagsComponent } from '../add-hashtags/add-hashtags.component';
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LightgalleryModule } from 'lightgallery/angular';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SponsorDetailsComponent } from '../sponsor-details/sponsor-details.component';
import { WebQrComponent } from '../web-qr/web-qr.component';
import { SharedModule } from "../../shared/shared.module";


@NgModule({
  declarations: [
    UploadEventQrComponent,
    AddHashtagsComponent,
    SponsorDetailsComponent,
    WebQrComponent
  ],
  imports: [
    CommonModule,
    PhotowallRoutes,
    MatDividerModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatExpansionModule,
    FormsModule,
    HttpClientModule,
    LightgalleryModule,
    ClipboardModule,
    MatCardModule,
    MatChipsModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatGridListModule,
    MatDialogModule, MatAutocompleteModule,
    MatToolbarModule,
    NgxSkeletonLoaderModule,
    MatSidenavModule,
    MatListModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    SharedModule
]
})
export class PhotowallModule { }